<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>Delegation Details</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="allUsers"
                label="Select Receiver"
                item-value="item"
                class="added-receiver"
                v-model="user"
              >
                <template slot="selection" slot-scope="{ item }">
                  <!-- HTML that describe how select should render selected items -->
                  {{ item.first_name }} {{ item.middle_name }}
                  {{ item.last_name }}

                  <span class="blue--text ml-2">
                    --
                    {{
                      item.positions[0]
                        ? item.positions[0].name
                        : " no position assigned "
                    }}
                  </span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <!-- HTML that describe how select should render selected items -->
                  {{ item.first_name }} {{ item.middle_name }}
                  {{ item.last_name }}

                  <span class="blue--text ml-2">
                    --
                    {{
                      item.positions[0]
                        ? item.positions[0].name
                        : " no position assigned "
                    }}
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="datetime_due"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="datetime_due"
                    v-model="computedDateTimeDue"
                    label="Effective Until"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="datetime_due" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(datetime_due)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <p class="text-center red--text">{{ errorMessage }}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="close">Close</v-btn>
        <v-btn text color="indigo" @click="saveDelegate">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  name: "DelegateRouteDialog",
  props: {
    routeId: Number,
    dialog: Boolean,
    userAssigned: Number,
    initiatorDueDate: String,
    accessFrom: String,
  },
  data() {
    return {
      fetchStatus: false,
      user: null,
      datetime_due: this.initiatorDueDate,
      menu: false,
      errorMessage: "",
    };
  },
  methods: {
    ...mapActions(["fetchUsers", "delegateSubroute"]),
    close() {
      this.user = null;
      this.$emit("closeDialog", false);
    },
    saveDelegate() {
      this.errorMessage = "";
      if (!this.user) {
        this.errorMessage = "Must select a user to delegate";
        return;
      }

      if (this.user.id == this.userAssigned) {
        this.errorMessage =
          "Cannot delegate sub-route to the default user assigned";
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "Confirmation to delegate this sub-route.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.isConfirmed) {
          const body = {
            data: {
              route_id: this.routeId,
              user_id: this.user.id,
              dateEffectiveUntil: this.datetime_due,
            },
            accessFrom: this.accessFrom,
            user: this.user,
          };

          this.delegateSubroute(body).then((res) => {
            if (res) {
              Swal.fire("Done!", "Sub-route has been delegated.", "success");
              this.close();
            }
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["allUsers"]),
    computedDateTimeDue() {
      return moment(new Date(this.datetime_due)).format("dddd, MMMM DD YYYY");
    },
  },
  watch: {
    dialog() {
      if (this.dialog && !this.fetchStatus && this.allUsers.length < 1) {
        this.fetchUsers({
          filter: this.userAssigned,
          itemsPerPage: 0
        });
      }
    },
  },
};
</script>

<style></style>
